import {
    getStartPageConfig,
    getTrendingBrands,
    getTrendingSearches,
    getWishListItems
} from './api';
import {
    setStartPageConfigAction,
    setStartPageConfigStatusAction,
    setTrendingBrandsAction,
    setTrendingBrandsStatusAction,
    setTrendingSearchesAction,
    setTrendingSearchesStatusAction,
    setWishListAction,
    setWishListStatusAction
} from './reducer';
import { selectPreferredLanguage } from 'tradera-state/language';
import itemActions from 'tradera-state/items/actions';

const defaultStartPageConfig = {
    header: {
        alternativeText: '',
        backgroundImage: null,
        isCampaignMode: false,
        webpageUrl: ''
    },
    content: [
        {
            type: 'lastChance'
        },
        {
            type: 'recentlyViewed'
        }
    ]
};

export const fetchStartPageConfig = () => async (dispatch, getState) => {
    const { status } = getState().views.startPage;
    if (status !== 'NOT_FETCHED') return;

    dispatch(setStartPageConfigStatusAction({ status: 'LOADING' }));

    const config = await getStartPageConfig(
        selectPreferredLanguage(getState()).languageCodeIso2
    );

    dispatch(
        setStartPageConfigAction({
            config: config || defaultStartPageConfig,
            status: 'HAS_DATA'
        })
    );
};

export const fetchTrendingBrandsIfNeeded = () => async (dispatch, getState) => {
    const { status } = getState().views.startPage.trendingBrands;
    if (status !== 'NOT_FETCHED') return;

    dispatch(setTrendingBrandsStatusAction({ status: 'LOADING' }));

    const brandsResult = await getTrendingBrands();

    const newStatus = brandsResult.length > 0 ? 'HAS_DATA' : 'HAS_NO_DATA';
    dispatch(
        setTrendingBrandsAction({ items: brandsResult, status: newStatus })
    );
};

export const fetchTrendingSearchesIfNeeded = () => async (
    dispatch,
    getState
) => {
    const { status } = getState().views.startPage.trendingSearches;
    if (status !== 'NOT_FETCHED') return;

    dispatch(setTrendingSearchesStatusAction({ status: 'LOADING' }));

    const searchesResult = await getTrendingSearches();

    const newStatus = searchesResult.length > 0 ? 'HAS_DATA' : 'HAS_NO_DATA';
    dispatch(
        setTrendingSearchesAction({ items: searchesResult, status: newStatus })
    );
};

export const fetchWishList = () => async (dispatch, getState) => {
    const { status } = getState().views.startPage.wishList;
    if (status === 'LOADING') return;

    dispatch(setWishListStatusAction({ status: 'LOADING' }));

    const items = await getWishListItems();
    dispatch(itemActions.add(items));

    const itemIds = items.map(item => item.itemId);

    const newStatus = items.length > 0 ? 'HAS_DATA' : 'HAS_NO_DATA';
    dispatch(setWishListAction({ itemIds: itemIds, status: newStatus }));
};
